/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { billingAPI } from 'api/billing'
import { PaymentMethodData } from 'models/billing'

/**********************************************************************************************************
 *    SLICE
 **********************************************************************************************************/
type Invoice = number | undefined

interface AppState {
    defaultPaymentMethod: PaymentMethodData | undefined,
    savePaymentMethodStatus: 'idle' | 'loading' | 'success' | 'error',
    invoice: Invoice
}

const initialState: AppState = {
    defaultPaymentMethod: undefined,
    savePaymentMethodStatus: 'idle',
    invoice: undefined
}

export const billingSlice = createSlice({
    name: 'billing',
    initialState,
    reducers: {
        setInvoice: (state, action: PayloadAction<Invoice>) => {
            state.invoice = action.payload
        }
    },
    extraReducers: (build) => {
        build
            .addMatcher(
                billingAPI.endpoints.accountPaymentMethods.matchFulfilled,
                (state, { payload }) => {
                    const paymentMethods = payload

                    if (paymentMethods?.length > 0) {
                        const method = paymentMethods.find(({ is_default: isDefault }) => isDefault)
                        state.defaultPaymentMethod = method
                    }
                }
            )
            .addMatcher(
                billingAPI.endpoints.savePaymentMethod.matchPending,
                (state) => {
                    state.savePaymentMethodStatus = 'loading'
                }
            )
            .addMatcher(
                billingAPI.endpoints.savePaymentMethod.matchFulfilled,
                (state) => {
                    state.savePaymentMethodStatus = 'success'
                }
            )
            .addMatcher(
                billingAPI.endpoints.savePaymentMethod.matchRejected,
                (state) => {
                    state.savePaymentMethodStatus = 'error'
                }
            )
    }
})

export const {
    setInvoice
} = billingSlice.actions

export default billingSlice.reducer
